<template>
  <v-select
    class="small-text-field"
    :error-messages="errorMessages"
    :required="required"
    :value="taxiType"
    :label="label"
    :items="bodyTypes"
    :v-model="taxiType"
    item-value="type"
    item-name="name"
    @input="updateSelf"
    hide-details
    :height="28"
    clearable
    outlined
    dense
    placeholder=" "
    style="width: 110px;"
  >
    <template v-slot:selection="{ item, index }">
      <span style="font-size: 12px !important">{{item.name}}</span>
    </template>
    <template v-slot:item="{ item, index }">
      <span style="font-size: 12px !important">{{item.name}}</span>
    </template>
  </v-select>
</template>

<script>
import { BookingForm } from "@/components/util/BookingForm.js";

export default {
  name: "SelectableBodyStyleInput",
  model: {
    prop: "taxiType",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    taxiType: String
  },
  data() {
    return {
      menu: false,
      bodyTypes: BookingForm.VEHICLE_TYPES()
    };
  },
  methods: {
    updateSelf(rideType) {
      this.$emit("input", rideType);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
